<template>
    <div class="box-second">
        <p class="title-crumb" style="height:6vh;">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>危大监测</el-breadcrumb-item>
                <el-breadcrumb-item>升降机监测</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button v-show="machType!=3" style="margin-left: 65%;" type="primary" size="mini" @click="baseconfig">基本参数配置</el-button>
            <el-button v-show="machType!=3" type="warning" size="mini" @click="config">参数配置</el-button>
            <el-button v-show="machType!=3" type="info" size="mini" @click="breat">设备心跳参数</el-button>
            <el-button v-show="machType==3" style="margin-left: 80%;" type="primary" size="mini" @click="enterdata">基本参数配置</el-button>
        </p>
        <div class="main">
            <div class="main-left">
                <div class="main-left-title"><div>设备列表</div><div @click="addRow()">添加</div></div>
                <div class="main-left-scroll">
                    <div class="main-left-item" v-for="(item,index) in towerlist" :key="index" :class="{'curTower':towerId==item.id}" @click="changeTower(item)">
                        <p class="name nowrap">{{item.name}}</p>
                        <p class="state" :class="{'color8':item.statusStr=='离线','color10':item.statusStr!='离线'}">{{item.statusStr}}</p>
                        <p class="num nowrap" :title="item.deviceId">编号：{{item.deviceId}}</p>
                    </div>
                </div>
            </div>
            <div class="main-right">
                <div class="main-right-f">
                    <div class="box1">
                        <div class="box-title">更新时间：{{allPart.updateDate}}</div>
                        <div class="box-cont">
                            <div class="box-cont-l">
                                <img src="../../assets/image/shengjiangji.png" alt="">
                            </div>
                            <div class="box-cont-r">
                                <p style="width:100%">
                                    <span>是否超重：</span>
                                    <span v-if="allPart.systemStatusWeight=='0'" style="color:#67C23A">正常</span>
                                    <span v-else-if="allPart.systemStatusWeight=='1'||allPart.systemStatusWeight=='2'" style="color:#F56C6C;">超载</span>
                                    <span v-else>正常</span>
                                </p>
                                <p style="width:100%">
                                    <span>实时楼层：</span>
                                    <span>{{allPart.floorNumber||'1'}}层</span>
                                </p>
                                <p style="width:100%">实时速度：{{ allPart.speed }}m/s</p>
                                <p style="width:100%">前门状态：{{allPart.foreDoorStatus=='0'?'开启':'关闭'}}</p>
                                <p style="width:100%">后门状态：{{allPart.behindDoorStatus=='0'?'开启':'关闭'}}</p>
                                <p style="width:100%">倾角度数：{{allPart.tilt||'0'}}°</p>
                            </div>
                        </div>
                    </div>
                    <div class="box2">
                        <div class="box-title">数据实时监测</div>
                        <div class="echrats" id="echrats"></div>
                    </div>
                </div>
                <div class="box-S">
                    <div style="box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
        border-radius: 6px;
        overflow: hidden;width:46.6%;height:100% ;position: relative;background:#fff;margin-top:1vh;border-radius: 5px;padding:0.6vh;display:flex;flex-wrap:wrap;">
                    <div style="width:100%;height:3.9vh;position: relative;display:flex;justify-content: space-between;align-items: center;padding:0.5vh;border-bottom:2px solid #E7E7E7FF;margin-bottom:8px">
                        <span style="font-size: 20px;
                                    font-family: PingFang SC;
                                    font-weight: 500;
                                    color: #666666;
                                    margin-bottom: 8px;
                                    ">预警记录</span>
                        <el-button size="mini" type="primary" @click="toMore">更多</el-button>
                    </div>
                    <div style="width:100%;height:calc( 100% - 4vh );position: relative;display:flex;flex-wrap:wrap;align-content: flex-start;overflow: auto;">
                        <div v-for="(item,index) in recordList" :key="index" style="width:100%;height:5vh;position: relative;display:flex;align-content: center;margin-bottom: 1.2vh;align-items: center;box-shadow: 0px 3px 10px 0px rgba(105, 159, 204, 0.44);border-radius: 6px;overflow: hidden;">
                            <div style="width:5vh;height:5vh;position: relative;background:#fff;display:flex;justify-content: center;align-items: center;">
                                <img :src="item.icon" style="max-width:5vh;max-height:5vh;" />
                            </div>
                            <p class="p-text" style="padding-left:0.9vh;width:11vh;color:red;text-align: start;position: relative;text-align: conter;font-size:0.8vw;">{{item.name}}</p>
                            <p class="p-text" style="margin-left:6vh;width:18vh;position: relative;text-align: left;color:red;font-size:0.8vw;">超预警限位:{{item.val}} {{item.unit}}</p>
                            <p style="width:calc( 100% - 40vh );position: relative;color:red;text-align: center;font-size:0.8vw;">{{item.createDate}}</p>
                        </div>
                        <!-- <div style="width:100%;height:6vh;position: relative;display:flex;align-content: center;margin-bottom: 2vh;align-items: center;background:#E7F1FB;border-radius: 4px;">
                            <div style="width:6vh;height:6vh;position: relative;background:#E5E5E5;display:flex;justify-content: center;align-items: center;">
                                <img src="../../assets/image/icon/kg.png" style="max-width:6vh;max-height:6vh;" />
                            </div>
                            <p style="padding-left:0.5vh;width:15vh;position: relative;text-align: left;font-size:0.8vw;">超重报警</p>
                            <p style="padding-left:0.5vh;width:19vh;position: relative;text-align: left;color:red;font-size:0.8vw;">超预警限位:36度</p>
                            <p style="width:calc( 100% - 40vh );position: relative;text-align: center;font-size:0.8vw;">报警时间：2020-01-05 12:23:45</p>
                        </div> -->
                    </div>
                </div>

                <!-- 特种设备操作人员列表 -->
                <div class="main-right-first" style="box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
        border-radius: 6px;
        overflow: hidden;margin-top:1vh;height:100%;width:52%;">
                    <p style="padding: 1vh;font-size:1vw;height:4.3vh;border-bottom: 2px solid rgb(231, 231, 231);border-bottom: 2px solid rgb(231, 231, 231);width:100%;display:flex;justify-content: space-between;align-items: center;">
                        <span style="font-size: 20px;
                                    font-family: PingFang SC;
                                    font-weight: 500;
                                    color: #666666">特种设备操作人员列表</span>
                        <!-- <el-date-picker
                          v-model="tableTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          @change="doFilter"
                          placeholder="选择日期">
                        </el-date-picker> -->
                        <el-button size="mini" type="primary" @click="enterrylb">更多</el-button>
                    </p>
                    <div class="special-table">
                        <el-table
                            :data="tableData"
                            height="33.5vh"
                            >
                            <el-table-column
                                prop="index"
                                label="序号">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名">
                            </el-table-column>
                            <el-table-column
                                prop="certificateNumber"
                                label="证件编号">
                            </el-table-column>
                            <el-table-column
                                prop="certificatePhoto"
                                label="查看证书">
                                <template slot-scope="scope">
                                    <el-image
                                        v-if="scope.row.certificatePhoto!=''"
                                        style="width: 6vh; height: 6vh;"
                                        :src="scope.row.certificatePhoto"
                                        :preview-src-list="scope.row.photoList"
                                    ></el-image>
                                    <div v-else class="no-photo" style="display: inline-block;">
                                        <span style="display: block;">暂无</span>
                                        <span style="display: block;">图片</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作记录" >
                                <template slot-scope="scope">
                                    <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                                        <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                </div>
                <!-- <div class="main-right-first">
                    <div class="real-data ele-real">
                        <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;">实时监控</p>
                        <div class="real-data-l" style="display:flex;">
                            <div style="width:50%;height:100%;position: relative;display:flex;flex-wrap:wrap;">
                                <p style="width:100%">
                                    <span>是否超重：</span>
                                    <span v-if="allPart.systemStatusWeight=='0'" style="color:#67C23A">正常</span>
                                    <span v-else-if="allPart.systemStatusWeight=='1'||allPart.systemStatusWeight=='2'" style="color:#F56C6C;">超载</span>
                                    <span v-else>正常</span>
                                </p>
                                <p style="width:100%">
                                    <span>实时楼层：</span>
                                    <span>{{allPart.floorNumber||'1'}}层</span>
                                </p>
                                <p style="width:100%">实时速度：{{ allPart.speed }}m/s</p>
                                <p style="width:100%">前门状态：{{allPart.foreDoorStatus=='0'?'开启':'关闭'}}</p>
                                <p style="width:100%">后门状态：{{allPart.behindDoorStatus=='0'?'开启':'关闭'}}</p>
                                <p style="width:100%">倾角度数：{{allPart.tilt||'0'}}°</p>
                                <p style="width:100%">更新时间：{{allPart.updateDate}}</p>
                            </div> -->
                            <!-- <p class="real-data-l-item" style="justify-content: space-around;">
                                <span style="width:auto;">额定载重：{{ allPart.weightReay }}kg</span>
                                <span style="width:auto;">额定高度：{{ allPart.height }}m</span>
                            </p>
                            <p class="real-data-l-item" style="justify-content: center;">
                                <span style="width:auto;">实时速度：{{ allPart.speed }}m/s</span>
                            </p> -->
                            <!-- <div class="real-data-l-item" style="width:50%;height:100%;align-items: flex-start;justify-content: center;">
                                <div v-if="allPart.speedStatus=='1'&& allPart.foreDoorStatus!='0'&& allPart.behindDoorStatus!='0'&& allPart.floorNumber!='1'" style="width:50%;height:100%;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/up-gif.gif" style="position: relative;width: 18vw;left: -6vw;" />
                                </div>
                                <div v-else-if="allPart.speedStatus=='2'&& allPart.foreDoorStatus!='0'&& allPart.behindDoorStatus!='0'&& allPart.floorNumber!='1'" style="width:50%;height:100%;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/down-gif.gif" style="position: relative;top: -10vh;width: 18vw;left: -6vw;" />
                                </div>
                                <div v-else style="width:50%;height:100%;;position: relative;padding-top:2vh;">
                                    <img src="../../assets/image/ele-stop.png" style="position: relative;width: 10vw;" />
                                </div>
                            </div>
                        </div>
                        <div class="real-data-r" style="width:50%;height:calc( 100% - 3vh );box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);padding: 0;">
                            <div id="dataChart" :style="{ height: '100%',width:'100%' }"></div>
                        </div>
                    </div>
                </div> -->
                <!--  -->
                <!-- <div class="dis" style="width:100%;height:calc( 100% - 50vh );position: relative;background:#fff;margin-top:1vh;border-radius: 5px;padding:1vh;display:flex;flex-wrap:wrap;">
                    <div style="width:100%;height:4vh;position: relative;display:flex;justify-content: space-between;align-items: flex-start;">
                        <span>最近预警记录</span>
                        <el-button size="mini" type="primary" v-if="deviceId" @click="toMore">更多</el-button>
                    </div>
                    <div style="width:50%;height:calc( 100% - 4vh );position: relative;display:flex;flex-wrap:wrap;align-content: flex-start;overflow: auto;">
                        <div v-for="(item,index) in recordList" :key="index" style="width:100%;height:6vh;position: relative;display:flex;align-content: center;margin-bottom: 2vh;align-items: center;background:#E7F1FB;border-radius: 4px;">
                            <div style="width:6vh;height:6vh;position: relative;background:#E5E5E5;display:flex;justify-content: center;align-items: center;">
                                <img :src="item.icon" style="max-width:6vh;max-height:6vh;" />
                            </div>
                            <p style="padding-left:0.5vh;width:15vh;position: relative;text-align: left;font-size:0.8vw;">{{item.name}}</p>
                            <p style="padding-left:0.5vh;width:19vh;position: relative;text-align: left;color:red;font-size:0.8vw;">超预警限位:{{item.val}} {{item.unit}}</p>
                            <p style="width:calc( 100% - 40vh );position: relative;text-align: center;font-size:0.8vw;">报警时间：{{item.createDate}}</p>
                        </div>
                    </div>
                    <div style="width:50%;height:calc( 100% - 4vh );position: relative;display:flex;overflow: hidden;">
                        <div style="width:50%;height:100%;position: relative;">
                            <div id="realDura" style="width:100%;height:100%"></div>
                        </div>
                        <div style="width:50%;height:100%;position: relative;">
                            <div id="realDura1" style="width:100%;height:100%;"></div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="main-right-first" style="margin-top:1vh;height:20vh;">
                    <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;">设备状态</p>
                    <div class="main-dure">
                        <p>
                            <span>高度</span>
                            <span v-if="eleState.systemStatusForelockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusForelockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.heightWarnCount}}</span></span>
                        </p>
                        <p>
                            <span>速度</span>
                            <span v-if="eleState.systemStatusBehindlockStatus=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusBehindlockStatus=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.speedWarnCount}}</span></span>
                        </p>
                    </div>
                    <div class="main-dure">
                        <p>
                            <span>姿态状态</span>
                            <span v-if="eleState.systemStatusTilt=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusTilt=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.tiltWarnCount}}</span></span>
                        </p>
                        <p>
                            <span>重量状态</span>
                            <span v-if="eleState.systemStatusWeight=='1'" class="color6">预警</span>
                            <span v-else-if="eleState.systemStatusWeight=='2'" style="color:red;">报警</span>
                            <span v-else class="color10">正常</span>
                            <span>预警次数 <span class="color6">{{towerH.weightWarnCount}}</span></span>
                        </p>
                        <el-button @click="deatilWarn" v-if="towerId&& towerId!=''" type="primary" style="position: absolute;top: 15px;right: 15px;"> 历史监测</el-button>

                    </div>
                </div> -->
                <!-- 特种设备操作人员列表 -->
                <!-- <div class="main-right-first" style="margin-top:1vh;height:auto;padding:1vh;min-height: 23.7vh;">
                    <p style="text-align: left;padding-left:1vh;font-size:1vw;height:3vh;width:100%;display:flex;justify-content: space-between;align-items: center;">
                        <span>特种设备操作人员列表</span>
                        <el-date-picker
                          v-model="tableTime"
                          value-format="yyyy-MM-dd"
                          type="date"
                          @change="doFilter"
                          placeholder="选择日期">
                        </el-date-picker>
                    </p>
                    <div class="special-table">
                        <el-table
                            :data="tableData"
                            style="width: 100%">
                            <el-table-column
                                prop="index"
                                label="序号">
                            </el-table-column>
                            <el-table-column
                                prop="name"
                                label="姓名">
                            </el-table-column>
                            <el-table-column
                                prop="certificateNumber"
                                label="证件编号">
                            </el-table-column>
                            <el-table-column
                                prop="certificatePhoto"
                                label="查看证书">
                                <template slot-scope="scope">
                                    <el-image
                                        v-if="scope.row.certificatePhoto!=''"
                                        style="width: 60px; height: 60px"
                                        :src="scope.row.certificatePhoto"
                                        :preview-src-list="scope.row.photoList"
                                    ></el-image>
                                    <div v-else class="no-photo" style="display: inline-block;">
                                        <span style="display: block;">暂无</span>
                                        <span style="display: block;">图片</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作记录" width="400">
                                <template slot-scope="scope">
                                    <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                                        <el-image
                                            v-if="scope.row.photoFile!=''"
                                            style="width: 6vh; height: 6vh;"
                                            :src="scope.row.photoFile"
                                            :preview-src-list="scope.row.photoList"
                                        ></el-image>
                                        <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div> -->
            </div>
        </div>
        <!-- 维护标准窗口 -->
        <el-dialog
            title="参数配置"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="60%"
        >
          <div class="config-con">
            <p class="config-con-item" v-for="(item,index) in configList" :key="index">
              <span style="display: inline-block;width: 6vw;">{{item.name}}</span>
              <!-- <span style="display: inline-block;width: 8vw;">单位：（{{item.unit}}）</span> -->
              <span v-if="item.type=='1'" style="display: inline-block;width: 18vw;color:#E6A23C;">设备预警限位：<el-input v-model="item.val" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
              <span v-if="item.type=='1'" style="display: inline-block;width: 18vw;color:#F56C6C;">设备报警限位：<el-input v-model="item.val1" placeholder="请输入" style="width:5vw;"></el-input> {{item.unit}}</span>
              <span v-if="item.type=='2'" style="display: inline-block;width: 18vw;color:#409EFF;">设置值：<el-input v-model="item.val" placeholder="请输入" style="width:8vw;"></el-input> {{item.unit}}</span>
              <span v-if="item.type=='2'" style="display: inline-block;width: 18vw;"></span>
            </p>
          </div>
          <div slot="footer" class="dialog-footer" >
              <el-button @click="editFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="sumbitEditRow" :disabled="disabled">确 定</el-button>
              <el-button type="info" @click="setDetfaule">恢复默认值</el-button>
          </div>
        </el-dialog>
        <!-- 新增设备 -->
        <el-dialog
                    :title="dialogTitle"
                    :visible.sync="addFormVisible"
                    center
                    :append-to-body="true"
                    :lock-scroll="false"
                    class="add-form"
                    width="30%"
                
                >
                    <el-form
                    :model="addForm"
                    ref="addForm"
                    label-width="200px"
                    :label-position="labelPosition"
                    :rules="rules"
                    >
                    <el-form-item label="设备名称：" prop="name">
                        <el-input
                        v-model="addForm.name"
                        placeholder="请输入设备名称"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="厂家名称：" prop="machType">
                        <el-select v-model="addForm.machType">
                        <el-option
                            v-for="item in crane"
                            :key="item.val"
                            :label="item.perName"
                            :value="item.val"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号：" prop="deviceId">
                        <el-input
                        v-model="addForm.deviceId"
                        placeholder="请输入设备编号"
                        autocomplete="off"
                        style="width:216px;"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="人脸识别编号:">
                        <el-select v-model="addForm.attendanceSn" @change="$forceUpdate()">
                        <el-option
                            v-for="item in groups"
                            :key="item.id"
                            :label="item.imei"
                            :value="item.imei"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="班组:">
                        <el-select v-model="addForm.teamsId" @change="$forceUpdate()">
                        <el-option
                            v-for="item in teams"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                    </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                    <el-button @click="addFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                    </div>
                </el-dialog>
                </el-table>
        <!-- 基本参数配置 -->
        <el-dialog
            title="基本参数配置"
            :visible.sync="configFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="40%"
        >
          <div class="config-con">
              <div style="width:100%" >
                <p style="font-weight: bolder;color: #e6a23c;">高度传感器</p>
                <p class="item-one" >
                  <span style="display: inline-block;width: 13vw;">高度传感器上限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_max" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 13vw;">高度传感器下限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_min" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <!-- <p  class="item-one" >
                  <span style="display: inline-block;width: 13vw;">吊钩最低处距大臂距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_max_distance" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 13vw;">吊钩最高处距大臂距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="heightSensor.height_min_distance" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p> -->
              </div>

              <!-- <div style="width:50%">
                <p style="font-weight: bolder;color: #e6a23c;">幅度传感器</p>
                <p class="item-one" >
                  <span style="display: inline-block;width: 15vw;">幅度传感器远限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_max" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">幅度传感器近限
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_min" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">小车最远处距驾驶舱距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_max_distance" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                  <span style="display: inline-block;width: 15vw;">小车最近处距驾驶舱距离
                  </span>
                  <span style="display: inline-block;width: 8vw;">单位：(米)</span>
                  <span style="display: inline-block;width: 25vw;color:#409EFF;">设置值：<el-input v-model="radiusSensor.radius_min_distance" placeholder="请输入" style="width:10vw;"></el-input> </span>
                </p>
              </div> -->
          </div>
          <div slot="footer" class="dialog-footer">
              <el-button @click="configFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="configRow">确 定</el-button>
              <!-- <el-button type="info" @click="setDetfaule">恢复默认值</el-button> -->
          </div>
        </el-dialog>
        <!-- 设备心跳参数 -->
        <el-dialog
            title="设备心跳参数"
            :visible.sync="beatFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            custom-class='tower-dig'
            class="add-form"
            width="30%"
        >
        <div class="config-con">
            <div style="width:100%" >
                <p class="item-one" >
                <span style="display: inline-block;width: 25vw;">高度传感器
                </span>
                <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.heightSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p>

                <!-- <p  class="item-one" >
                <span style="display: inline-block;width: 25vw;">回转传感器
                </span>
                <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.angleSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                <span style="display: inline-block;width: 25vw;">幅度传感器
                </span>
                <span style="display: inline-block;width: 50vw;color:#409EFF;">值：<el-input v-model="beatForm.radiusSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p>

                <p  class="item-one" >
                <span style="display: inline-block;width:25vw;">重量传感器
                </span>
                <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.loadweightrSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p>
                <p  class="item-one" >
                <span style="display: inline-block;width:25vw;">风速传感器
                </span>
                <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.windspeedSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p> -->
                <p  class="item-one" >
                <span style="display: inline-block;width:25vw;">倾角传感器
                </span>
                <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.fallSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p>
                <!-- <p  class="item-one" >
                <span style="display: inline-block;width:25vw;">
                    按钮传感器
                </span>
                <span style="display: inline-block;width:50vw;color:#409EFF;">值：<el-input v-model="beatForm.buttonSensor" placeholder="" style="width:10vw;"></el-input> </span>
                </p> -->
            </div>
        </div>
        </el-dialog>
    </div>
</template>
<script>
import HighCharts from 'highcharts'
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            towerId:'',//当前塔吊id
            deviceId:'',//当前塔吊deviceId
            towerlist:[],//塔吊设备列表
            allPart:{},//当前塔吊信息
            towerH:{},//24小时数据
            tableData:[],//特种人员列表
            eleState:{},//项目预计状态
            // timeRefrsh:null,
            tableTime:util.myTime.getCurTime(),

            editFormVisible: false,
            configList:[
                {name:'重量',unit:'吨',val:'',val1:'',status:true,default:'3',type:'1',key:'customEarlyWarningWeight',key1:'customEarlyWeight'},
                {name:'人数',unit:'个',val:'',val1:'',status:true,default:'',type:'1',key:'customEarlyWarningPersonNum',key1:'customEarlyPersonNum'},
                {name:'速度',unit:'米每秒',val:'',val1:'',status:true,default:'3',type:'1',key:'customEarlyWarningSpeed',key1:'customEarlySpeed'},
                {name:'倾斜度',unit:'度',val:'',val1:'',status:true,default:'10',type:'1',key:'customEarlyWarningTilt',key1:'customEarlyTilt'},
                {name:'IP地址',unit:'',val:'',status:true,default:'',type:'2',key:'ipAddress'},
                {name:'4g卡号',unit:'',val:'',status:true,default:'',type:'2',key:'cardNumber'},
                {name:'频率',unit:'分',val:'',status:true,default:'',type:'2',key:'frequency'},
                {name:'层数',unit:'层',val:'',status:true,default:'',type:'2',key:'layerNumber'},
                {name:'最大载人数',unit:'个',val:'',status:true,default:'',type:'2',key:'largestManned'},
                {name:'额定重量',unit:'吨',val:'',status:true,default:'',type:'2',key:'ratedWeight'},
                {name:'额定高度',unit:'米',val:'',status:true,default:'',type:'2',key:'heightRating'},
            ],
            configData:{
                projectId:'',
                customEarlyWarningWeight:'',//自定义重量预警
                customEarlyWarningSpeed:'',//自定义速度预警
                customEarlyWarningPersonNum:'',//自定义人数预警
                customEarlyWarningTilt:'',//自定义倾斜预警
                ipAddress:'',
                cardNumber:'',
                frequency:'',
                layerNumber:'',
                largestManned:'',
                ratedWeight:'',
                heightRating:''
            },
            hasConf:false,//判断是否已经有配置
            disabled:false,
            recordList:[],//列表
            //websocket推送
            websocket:undefined,
            chartX:[],
            chartY:{},
            //基本参数配置
            configFormVisible:false,
            heightSensor:{
              height_max:'', //高度传感器上限
              height_min:'',//高度传感器下限
            //   height_max_distance:'',//吊钩距离大臂上限
            //   height_min_distance:'',//吊钩距离大臂下限
            },
            // radiusSensor:{
            //   radius_max:'',//幅度传感器上限
            //   radius_min:'',//幅度传感器下限
            //   radius_max_distance:'',//幅度传感器小车距离上限
            //   radius_min_distance:'',//幅度传感器小车距离下限
            // },
            //心跳
            beatFormVisible:false,
            beatForm:{
                heightSensor:'',
                fallSensor:''
            },
            machType:'', //设备类型
            echartsData:[],
            row:{},
            addFrom:{},
            addFormVisible:false,
            dialogTitle:'',
            addForm:{},
            rules: {
                name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
                machType: [
                { required: true, message: '请选择厂家名称', trigger: 'blur' }
                ],
                deviceId: [
                { required: true, message: '请输入设备编号', trigger: 'blur' }
                ]
            },
            crane: [
                { val: '1', perName: '海智' },
                { val: '2', perName: '瞳声' },
                { val: '3', perName: '瞳声2' },
            ],
            teams:[],
            labelPosition: 'right',
            groups:[],
            dataList3:['/T','/m','m/s','/°'],
            indexA:0
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getEleList()
        //this.setChart1()
        this.getList()
        
        
    },
    // destroyed: function() {
    //     if(this.timeRefrsh){
    //         window.clearTimeout(this.timeRefrsh)
    //     }
    // },
    methods:{
        getList() {
      var that = this
      myHttp.getRecogByProjectId({
          projectId: util.session.get('groupId')
      }).then(
          function(resp) {
            if (resp.data.code == '200') {
              //  console.log(resp)
              var list = resp.data.data.pageInfo || []
              that.groups = list
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          },
          function() {}
        )
    },
            // 获取班组
    getTeams() {
        // getTeamsListtz
        var that = this
        myHttp.getTeamsListtz({
          projectId: util.session.get('groupId')
        }).then(
          function(resp) {
            if (resp.data.code == '200') {
              that.teams = resp.data.data.teamsList || []
            } else {
              that.$message.error(resp.data.msg)
            }
          },
          function() {}
        )
    },
        sumbitAddRow(formName) {
      var that = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.addForm.projectId = that.groupId
          // console.log(that.addForm.id)
          if (that.addForm.id == '') {
            //添加
            myHttp.createElevator(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('添加成功')
                  that.addFormVisible = false
                  that.getEleList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          } else {
            //修改
            myHttp.updateElevator(that.addForm).then(
              function(resp) {
                if (resp.data.code == '200') {
                  that.$message.success('修改成功')
                  that.addFormVisible = false
                  that.getEleList()
                } else {
                  that.$message.error(resp.data.msg)
                }
              },
              function() {}
            )
          }
        }
      })
    },
        /**
       * 新增设备
       */
        addRow() {
            this.getTeams()
            this.dialogTitle = '新增设备'
            ;(this.addFormVisible = true),
                (this.addForm = {
                id: '',
                name: '',
                machType: '1',
                deviceId: '',
                attendanceSn: '',
                teamsId: ''
                })
        },
        enterrylb(){
            console.log(this.row)
            if(this.row.deviceId){
            this.$router.push({path:'/elepageWarn1/'+this.row.deviceId})
          }else{
            this.$message.error('暂无更多')
          }
        },
        mapFn() {
            let that = this
      // 基于准备好的dom，初始化echarts实例
      // var mapChart = this.$echarts.init(this.$refs.mapChart);
      var mapChart = this.$echarts.init(document.getElementById("echrats"));
      document.getElementById("echrats").removeAttribute('_echarts_instance_')
      mapChart.setOption({
           xAxis: {
    type: 'value'
  },
  yAxis: {
    splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#cccccc",
            },
          },
    type: 'category',
    data: ['重量','高度','速度','倾角',]
  },
  series: [
    {barWidth : 25,
      data: [that.allPart.weightReay||0,that.allPart.height||0,that.allPart.speed||0,that.allPart.tilt||0],
      type: 'bar',
      label: {
          show: true,
          position: 'right'
        },
      showBackground: true,
      itemStyle:{
        
        normal:{
            barBorderRadius: [0, 20, 20, 0],
            label: {
                  formatter: function(params){
                    that.indexA++
                    return params.value+' '+that.dataList3[that.indexA-1]
                  },
                  show: true,
                  position: "top",
                  textStyle: {
                    fontWeight: "",
                    fontSize: "14",
                    color: "#333333",
                  },
                },
        }
      },
    }
  ],
  grid: {
              left: '8%',
              right: '5%'
            }
      }),
        window.addEventListener("resize", () => {
          // 自动渲染echarts
          mapChart.resize();
        });
    },
        // 新设备跳转数据修改页面
        enterdata(){
            this.$router.push({
                path:'/eleProData',
                query:{
                    id:`${this.deviceId}`
                }
            })
        },
        //获取塔吊设备
        getEleList(){
            var that = this
            myHttp.getEleListByPage({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp,'9999')
                if(resp.data.code=='200'){
                    var list = resp.data.data.elevatorList||[]
                    that.towerlist = list
                    if(list.length>0 && that.towerId==''){
                        that.towerId = list[0].id
                        that.deviceId = list[0].deviceId
                    }
                    if(that.towerId!=''){
                        that.getHour()
                        that.getRealInfo()
                        that.getNowData()
                        that.getPerson()
                        that.initWebsocket()
                        that.row = resp.data.data.elevatorList[0]
                        that.echartsData = resp.data.data.elevatorList[0]
                        that.mapFn()
                    }
                    
                }
            })
        },
        getRealInfo(){
            var that = this
            myHttp.getEleInfoById({
                id:this.towerId
            }).then(function(resp){
              console.log(resp);
                that.machType = resp.data.data.elevator.machType
                if(resp.data.code=='200'){
                    var data = resp.data.data.elevator||{}
                    data.weightReay = data.weight && data.weightPercent?(parseFloat(data.weight)/parseFloat(data.weightPercent)*100).toFixed(2):''
                    data.speed = data.speed && data.speed!=''?parseFloat(data.speed).toFixed(2):0
                    data.tilt = data.tilt && data.tilt!=''?parseFloat(data.tilt).toFixed(1):0
                    that.allPart = data
                    console.log(that.allPart)
                    for(var i in that.beatForm){
                        that.beatForm[i] = data[i]
                    }
                }
            })
        },
        //获取最新10条数据
        getNowData(){
            var that = this
            myHttp.getElevatorMoreInfo({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                console.log(resp,'666666666')
                if(resp.data.code=='200'){
                    console.log(resp)
                    var list = resp.data.data.ElevatorLog||[]
                    list.reverse()
                    var time = []
                    var obj = {
                        speed:[],
                        weight:[],
                        height:[],
                        floorNumber:[]
                    }
                    for(var i=0;i<list.length;i++){
                        time.push(list[i].createDate)
                        obj.speed.push(list[i].speed)
                        // obj.weight.push(list[i].weight)
                        obj.height.push(list[i].height)
                        obj.floorNumber.push(list[i].floorNumber)
                    }
                    that.chartX = time
                    that.chartY = obj
                    // that.showLineNow(time,obj)
                }else{

                }
            },function(err){

            })
            
        },
        // showLineNow(time,obj){
        //     var option = {
        //         grid: {
        //         left: '1%',
        //         right: '1%',
        //         top: '10%',
        //         bottom: '5%',
        //         containLabel: true
        //         },
        //         color: ['#29AC5D', '#FF854E', '#892FD5', '#5473E8'],
        //         legend: {
        //             show: true,
        //             icon: 'circle',
        //             data: ['速度','重量','高度', '楼层'],
        //             right: '5%',
        //             textStyle: {
        //                 fontSize: 12,
        //                 color: '#666'
        //             }
        //         },
        //         tooltip: {
        //             trigger: 'axis',
        //         },
        //         xAxis: {
        //             type: 'category',
        //             data: time,
        //         // axisTick: {
        //         //     show: false
        //         // },
        //         // axisLine: {
        //         //     show: false
        //         // },
        //         // axisLabel: {
        //         //     show: true,
        //         //     interval: 1,
        //         //     textStyle: {
        //         //     color: '#1B3BF5',
        //         //     fontWeight: 'Bold'
        //         //     }
        //         // }
        //         },
        //         yAxis: {
        //             type: 'value',
        //             axisTick: {
        //                 show: false
        //             },
        //             axisLine: {
        //                 show: false
        //             }
        //         },
        //         series: [
        //         {
        //             name: '速度',
        //             data: obj.speed,
        //             type: 'line',
        //             symbol: 'none',
        //             itemStyle: {
        //             normal: {
        //                 barBorderRadius: 0,
        //                 lineStyle: {
        //                 width: 2,
        //                 }
        //             }
        //             },
        //             smooth: true
        //         },
        //         {
        //             name: '重量',
        //             data: obj.weight,
        //             type: 'line',
        //             symbol: 'none',
        //             itemStyle: {
        //             normal: {
        //                 barBorderRadius: 0,
        //                 lineStyle: {
        //                   width: 2,
        //                 }
        //             }
        //             },
        //             smooth: true
        //         },
        //         {
        //             name: '高度',
        //             data: obj.height,
        //             type: 'line',
        //             symbol: 'none',
        //             itemStyle: {
        //             normal: {
        //                 barBorderRadius: 0,
        //                 lineStyle: {
        //                 width: 2,
        //                 // color: '#892FD5'
        //                 }
        //             }
        //             },
        //             smooth: true
        //         },
        //         {
        //             name: '楼层',
        //             data: obj.floorNumber,
        //             type: 'line',
        //             symbol: 'none',
        //             itemStyle: {
        //             normal: {
        //                 barBorderRadius: 0,
        //                 lineStyle: {
        //                 width: 2,
        //                 // color: '#5473E8'
        //                 }
        //             }
        //             },
        //             smooth: true
        //         }
        //         ]
        //     }
        //     var page = this.$echarts.init(document.getElementById('dataChart'))
        //     page.setOption(option)
        // },
        //获取24小时监测数据
        getHour(){
            var that = this
            this.recordList = []
            myHttp.latelyWarnInformation({
                projectId:this.groupId,
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    // that.setChart1(data.todayMap)
                    // that.setChart2(data.allDayMap)
                    //高度预警
                    let list = []
                    var obj1 = data.latelyHeightWarn
                    if(obj1){
                        obj1.icon = require('../../assets/image/icon/gd.png')
                        obj1.name = '高度预警'
                        obj1.val = parseFloat(obj1.height).toFixed(2)
                        obj1.unit = '米'
                        list.push(obj1)
                    }
                    //速度预警
                    var obj2 = data.latelySpeedWarn
                    if(obj2){
                        obj2.icon = require('../../assets/image/icon/fs.png')
                        obj2.name = '速度预警'
                        obj2.val = parseFloat(obj2.speed).toFixed(2)
                        obj2.unit = '米每秒'
                        list.push(obj2)
                    }
                    //姿态预警
                    var obj3 = data.latelyTiltWarn
                    if(obj3){
                        obj3.icon = require('../../assets/image/icon/qs.png')
                        obj3.name = '姿态预警'
                        obj3.val = parseFloat(obj3.tilt).toFixed(1)
                        obj3.unit = '度'
                        list.push(obj3)
                    }
                    //重量预警
                    var obj4 = data.latelyWeightWarn
                    if(obj4){
                        obj4.icon = require('../../assets/image/icon/kg.png')
                        obj4.name = '重量预警'
                        obj4.val = parseFloat(obj4.weight).toFixed(2)
                        obj4.unit = '吨'
                        list.push(obj4)
                    }
                    that.recordList = list
                    console.log(that.recordList)
                }
            })
            
        },
        //24小时监测时长
        // setChart1(obj){
        //     var data = {
        //         heightWarnCount:obj.heightWarnCount||0,
        //         speedWarnCount:obj.speedWarnCount||0,
        //         tiltWarnCount:obj.tiltWarnCount||0,
        //         weightWarnCount:obj.weightWarnCount||0
        //     }
        //     var all = parseInt(data.heightWarnCount)+parseInt(data.speedWarnCount)+parseInt(data.tiltWarnCount)+parseInt(data.weightWarnCount)
        //     var option = {
        //         title:{
        //             text:all,
        //             textStyle:{
        //                 fontSize:'30',
        //                 fontWeight:'bold'
        //             },
        //             subtext:'24小时预警',
        //             subtextStyle:{
        //                 fontSize:'16',
        //                 color:'#333',
        //             },
        //             left:'center',
        //             top:'middle',
        //         },
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{a} <br/>{b}: {c} ({d}%)'
        //         },
        //         legend: {
        //             orient: 'vertical',
        //             left: 10,
        //             data: ['高度预警', '速度预警', '姿态状态', '重量预警'],
        //             show:false,
        //         },
        //         color: ['#09B0B6', '#8973FC', '#FE7396', '#038BF9'],
        //         series: [
        //             {
        //                 name: '24小时预警',
        //                 type: 'pie',
        //                 center:['50%','50%'],
        //                 radius: ['50%', '70%'],
        //                 avoidLabelOverlap: false,
        //                 label: {
        //                     show: false,
        //                     position: 'center'
        //                 },
        //                 emphasis: {
        //                     label: {
        //                         show: false,
        //                         fontSize: '30',
        //                         fontWeight: 'bold'
        //                     }
        //                 },

        //                 labelLine: {
        //                     show: false
        //                 },
        //                 data: [
        //                     {value: data.heightWarnCount, name: '高度预警'},
        //                     {value: data.speedWarnCount, name: '速度预警'},
        //                     {value: data.tiltWarnCount, name: '姿态状态'},
        //                     {value: data.weightWarnCount, name: '重量预警'},
        //                 ]
        //             }
        //         ]
        //     };
        //     var page = this.$echarts.init(document.getElementById('realDura'))
        //     page.setOption(option)
        // },

        // //总报警
        // setChart2(obj){
        //     var data = {
        //         heightWarnCount:obj.heightWarnCount||0,
        //         speedWarnCount:obj.speedWarnCount||0,
        //         tiltWarnCount:obj.tiltWarnCount||0,
        //         weightWarnCount:obj.weightWarnCount||0
        //     }
        //     var all = parseInt(data.heightWarnCount)+parseInt(data.speedWarnCount)+parseInt(data.tiltWarnCount)+parseInt(data.weightWarnCount)
        //     var option = {
        //         title:{
        //             text:all,
        //             textStyle:{
        //                 fontSize:'30',
        //                 fontWeight:'bold'
        //             },
        //             subtext:'总报警记录',
        //             subtextStyle:{
        //                 fontSize:'16',
        //                 color:'#333',
        //             },
        //             left:'center',
        //             top:'middle',
        //         },
        //         tooltip: {
        //             trigger: 'item',
        //             formatter: '{a} <br/>{b}: {c} ({d}%)'
        //         },
        //         legend: {
        //             orient: 'vertical',
        //             left: 10,
        //             data: ['高度预警', '速度预警', '姿态状态', '重量预警'],
        //             show:false,
        //         },
        //         color: ['#09B0B6', '#8973FC', '#FE7396', '#038BF9'],
        //         series: [
        //             {
        //                 name: '总报警记录',
        //                 type: 'pie',
        //                 center:['50%','50%'],
        //                 radius: ['50%', '70%'],
        //                 avoidLabelOverlap: false,
        //                 label: {
        //                     show: false,
        //                     position: 'center'
        //                 },
        //                 emphasis: {
        //                     label: {
        //                         show: false,
        //                         fontSize: '30',
        //                         fontWeight: 'bold'
        //                     }
        //                 },

        //                 labelLine: {
        //                     show: false
        //                 },
        //                 data: [
        //                     {value: data.heightWarnCount, name: '高度预警'},
        //                     {value: data.speedWarnCount, name: '速度预警'},
        //                     {value: data.tiltWarnCount, name: '姿态状态'},
        //                     {value: data.weightWarnCount, name: '重量预警'},
        //                 ]
        //             }
        //         ]
        //     };
        //     var page = this.$echarts.init(document.getElementById('realDura1'))
        //     page.setOption(option)
        // },

        //获取人员
        getPerson(){
            var that = this
            myHttp.getTzListByTeamsId({
                projectId:this.groupId,
                teamsId:this.getTeamId(this.deviceId),
                daysss:this.tableTime,
                status:'2',
                attendanceSn:this.getSn(this.deviceId)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.attendList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].certificatePhoto = list[i].certificatePhoto && list[i].certificatePhoto!=''?base.httpCtx+list[i].certificatePhoto:''
                        list[i].photoList = []
                        if(list[i].certificatePhoto!=''){
                            list[i].photoList.push(list[i].certificatePhoto)
                        }
                        list[i].photoFile = list[i].photoFile && ''!=list[i].photoFile?base.httpCtx+list[i].photoFile:''
                        if(list[i].photoFile!=''){
                            list[i].photoList.push(list[i].photoFile)
                        }
                        list[i].index = (i+1)
                    }
                    that.tableData = list
                }
            })
        },
        //获取班组id
        getTeamId(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].teamsId
                }
            }
            return result
        },
        //获取sn
        getSn(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].attendanceSn
                }
            }
            return result
        },

        //选择塔吊
        changeTower(obj){
            this.indexA = 0
            this.towerId = obj.id
            this.deviceId = obj.deviceId
            this.getHour()
            this.getRealInfo()
            this.getPerson()
            this.getNowData()
            this.row = obj
            this.mapFn()
        },
        //
        doFilter(){
            this.getPerson()
        },

        //跳转查看信息
        attendInfo(row){
            this.$router.push({ name: 'specialPerson',params:{id:this.towerId,personId:row.personId,status:'2'} })
        },
         // 跳转预警监测页面
        deatilWarn(){
            var id = this.deviceId
            this.$router.push({path:'/eleWarn/'+id})
        },

        //数据转列表
        setConfigList(data){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = data[this.configList[i].key]||''
                if(this.configList[i].key1){
                    this.configList[i].val1 = data[this.configList[i].key1]||''
                }
                // if(i==0){
                //     this.configList[i].val = data.customEarlyWarningWeight
                // }else if(i==1){
                //     this.configList[i].val = data.customEarlyWarningHeight
                // }else if(i==2){
                //     this.configList[i].val = data.customEarlyWarningSpeed
                // }else if(i==3){
                //     this.configList[i].val = data.customEarlyWarningTilt
                // }
            }
        },

        //配置
        config(){
            this.dialogTitle = '参数配置'
            this.editFormVisible = true
            this.configData = {
                projectId:'',
                customEarlyWarningWeight:'',//自定义重量预警
                customEarlyWarningSpeed:'',//自定义速度预警
                customEarlyWarningPersonNum:'',//自定义人数预警
                customEarlyWarningTilt:'',//自定义倾斜预警
                ipAddress:'',
                cardNumber:'',
                frequency:'',
                layerNumber:'',
                largestManned:'',
                ratedWeight:'',
                heightRating:''
            }
            this.setConfigList({})
            var that = this
            myHttp.findEquipElevatorConfig({
                projectId:util.session.get('groupId'),
                deviceId:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    if(data){
                        that.hasConf = true
                        that.configData = data
                        that.setConfigList(data)
                    }else{
                        that.hasConf = false
                        
                    }
                }else{
                that.$message.error(resp.data.msg)
                }
            })
        },

        // 维护环境标准configData
        sumbitEditRow(formName) {
            var that = this
            this.disabled = true
            for(var i=0;i<this.configList.length;i++){
                if(this.configList[i].type=='1'){
                    this.configData[this.configList[i].key] = this.configList[i].val
                    this.configData[this.configList[i].key1] = this.configList[i].val1
                }else{
                    this.configData[this.configList[i].key] = this.configList[i].val
                }
            }
            this.configData.projectId = util.session.get('groupId')
            delete this.configData.createDate
            delete this.configData.updateDate
            this.configData.createBy = util.session.get('user').id
            this.configData.deviceId = this.deviceId
            myHttp.setUpEquipElevatorConfig(this.configData).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('配置成功')
                    that.editFormVisible = false
                    that.disabled = false
                }else{
                    that.$message.error(resp.data.msg)
                    that.disabled = false
                }
            },function(){that.disabled = false})
            // if(this.hasConf){
            //     this.configData.updateBy = util.session.get('user').id
            //     myHttp.updateElevatorCopy(this.configData).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.$message.success('配置成功')
            //         that.editFormVisible = false
            //     }else{
            //         that.$message.error(resp.data.msg)
            //     }
            //     })
            // }else{
            //     this.configData.createBy = util.session.get('user').id
            //     myHttp.addElevatorCopy(this.configData).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.$message.success('配置成功')
            //         that.editFormVisible = false
            //     }else{
            //         that.$message.error(resp.data.msg)
            //     }
            //     })
            // }
        },

        //恢复默认值
        setDetfaule(){
            for(var i=0;i<this.configList.length;i++){
                this.configList[i].val = this.configList[i].default
            }
        },

        //查看更多
        toMore(){
            this.$router.push({path:'/eleWarn/'+this.deviceId})
        },

        /**
         * websocket
         */
        initWebsocket(){
            var that = this;
            //判断当前浏览器是否支持WebSocket
            if(this.websocket && this.websocket!=''){
                this.websocket.close();
            }
            if('WebSocket' in window){
                var url = ''
                if(document.location.protocol=="https:"){
                    url = base.httpsWs+"/webSocketEquip/"+this.groupId;//wss地址;
                }else{
                    url = base.httpWs+"/webSocketEquip/"+this.groupId;//ws地址;
                }
                // var url = base.httpWs+"/webSocketEquip/"+this.groupId;
                that.websocket = new WebSocket(url);
            }
            else{
                console.log('Not support websocket')
            }
            //连接发生错误的回调方法
            this.websocket.onerror = function(){

            };
            //连接成功建立的回调方法
            this.websocket.onopen = function(event){
                // that.errorFlag = false
                // that.timeOutObj=null;
            }
            //接收到消息的回调方法
            this.websocket.onmessage = function(event){
                if(event.data=="连接成功")return;
                var x=JSON.parse(event.data);
                // console.log('==========deep1====websocket=================')
                console.log(x,'10086')
                if(x.flag=='8'){
                    that.refreshData(x.elevator)
                }
            }
            //连接关闭的回调方法
            this.websocket.onclose = function(){
                this.timeOutObj=setTimeout(function(){
                    that.initWebsocket();
                }, 60000);
            }
            //监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
            window.onbeforeunload = function(){
                that.websocket.close();
            }
        },
        //关闭连接
        closeWebSocket(){
            this.websocket.close();
        },

        //刷新数据
        refreshData(obj){
            console.log(obj)
            if(obj.deviceId == this.deviceId){
                this.allPart.systemStatusWeight = obj.systemStatusWeight
                this.allPart.floorNumber = obj.floorNumber
                this.allPart.speed = obj.speed
                this.allPart.speedStatus = obj.speedStatus
                this.allPart.foreDoorStatus = obj.foreDoorStatus
                this.allPart.behindDoorStatus = obj.behindDoorStatus
                this.allPart.tilt = obj.tilt
                this.allPart.updateDate = util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss')
                if(this.chartX.length>4){
                    this.chartX.shift()
                    this.chartY.speed.shift()
                    this.chartY.height.shift()
                    this.chartY.floorNumber.shift()
                    this.chartX.push(util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss'))
                    this.chartY.speed.push(obj.speed)
                    this.chartY.height.push(obj.height)
                    this.chartY.floorNumber.push(obj.floorNumber)
                }else{
                    this.chartX.push(util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss'))
                    this.chartY.speed.push(obj.speed)
                    this.chartY.height.push(obj.height)
                    this.chartY.floorNumber.push(obj.floorNumber)
                }
                console.log(this.chartX)
                console.log("=================obj.updateDate================="+util.myTime.formatTime(obj.updateDate,'YYYY-MM-dd HH:mm:ss'))
                this.showLineNow(this.chartX,this.chartY)
            }
        },

        // 基本参数配置
        baseconfig (){
            this.configFormVisible = true
            // selectTowerBasicConfiguration
            this.heightSensor={
              height_max:'', //高度传感器上限
              height_min:'',//高度传感器下限
            //   height_max_distance:'',//吊钩距离大臂上限
            //   height_min_distance:'',//吊钩距离大臂下限
            }
            // this.radiusSensor={
            //   radius_max:'',//幅度传感器上限
            //   radius_min:'',//幅度传感器下限
            //   radius_max_distance:'',//幅度传感器小车距离上限
            //   radius_min_distance:'',//幅度传感器小车距离下限
            // }
            var that = this
            myHttp.selectElevatorBasicConfiguration({
                projectId:util.session.get('groupId'),
                imei:this.deviceId
            }).then(function(resp){
                if(resp.data.code=='200'){
                 var data = resp.data.data
                 if(data.heightSensor){
                  var str = JSON.parse( data.heightSensor)
                  for(var i in that.heightSensor){
                      that.heightSensor[i] = str[i]
                  }
                 }
                }else{
                that.$message.error(resp.data.msg)
                }
            })
        },
        // 确定配置
        configRow(formName){
          var that = this
          var heightSensor = JSON.stringify( this.heightSensor)
        // var radiusSensor = JSON.stringify( this.radiusSensor)
          myHttp.setUpEquipElevatorConfig({
            projectId:util.session.get('groupId'),
            deviceId:this.deviceId,
            heightSensor:heightSensor,
          }).then(function(resp){
          if(resp.data.code=='200'){
              that.$message.success('配置成功')
              that.configFormVisible = false
          }else{
              that.$message.error(resp.data.msg)
          }
          })
        //   myHttp.updateElevatorBasicConfiguration({
        //       deviceId:this.deviceId,
        //       heightSensor:heightSensor,
        //   }).then(resp=>{
        //     if(resp.data.code=='200'){
        //         that.$message.success('配置成功')
        //         that.configFormVisible = false
        //     }else{
        //         that.$message.error(resp.data.msg)
        //     }
        //   })
        },
        // 心跳设置
        breat(){
            this.beatFormVisible = true
            var that = this
            myHttp.getEleInfoById({
                id:this.towerId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.elevator||{}
                    for(var i in that.beatForm){
                        that.beatForm[i] = data[i]
                    }
                }
            })
            // myHttp.getTowerInfoByPage({
            //     projectId:util.session.get('groupId'),
            //     id:this.towerId
            // }).then(function(resp){
            //     if(resp.data.code=='200'){
            //       console.log(resp)
            //      var data = resp.data.data.tower
            //      that.beatForm = data

            //     }else{
            //     that.$message.error(resp.data.msg)
            //     }
            // })

        },
    },
    destroyed(){
        this.closeWebSocket()
    },
}
</script>
<style scoped>
    @import '../../assets/css/clock.css';
    .main-left{
        width: 14.1vw;
        height: 100%;
        position: relative;
        padding: 1vh 0.3vh;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        background: #fff;
        align-content: flex-start;
        box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
border-radius: 6px;
    }
    .main-left-item{
        height: 8.5vh;
        width: 100%;
        position: relative;
        background: #EFEFEF;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 0.5vh 1.2vw;
        cursor: pointer;
        margin-top: 0.3vh;
        border-radius: 6px;
    }
    .main-left-title{
        height: 4vh;
        width: 100%;
        position: relative;
        /* background: #EFEFEF; */
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        padding: 0 0.6vw;
        cursor: pointer;
        margin-bottom: 0.9vh;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .main-left-title::after{
        position: absolute;
        content: "";
        width: 14.3vw;
        height: 2px;
        background-color: #E7E7E7;
        left: -0.6vw;
        bottom: -10px;
        z-index: 99;
    }
    .main-left-title>div:nth-child(1){
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
    }
    .main-left-title>div:nth-child(2){
        width: 70px;
        height: 36px;
        background: rgba(11, 98, 240, 0.8);
        border-radius: 6px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 36px;
    }
    .main-left-item p{
        height: 3vh;
        position: relative;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .main-left-item .name{
        width: calc( 100% - 3vw );
        position: relative;
    }
    .main-left-item .state{
        width: 3vw;
        position: relative;
        justify-content: flex-end;
    }
    .main-left-item .num{
        width: 100%;
        position: relative;
    }
    .curTower{
        background: #B9DAF5;
    }
    .curTower .name,.curTower .state,.curTower .num{
        color: #fff;
    }

    .main-right{
        width: calc( 100% - 14.1vw );
        height: 100%;
        position: relative;
        padding: 0 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        overflow:auto;
    }
    .main-right-first{
        width: 100%;
        height: 40vh;
        position: relative;
        border-radius: 6px;
        background: #fff;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
    }
    .real-data-l,.real-data-r{
        width:50%;
        height:calc( 100% - 3vh );
        padding:2vh 5vh;
    }
    .real-data-l-item{
        width:100%;
        display:flex;
        height:6vh;
        align-items: flex-end;
        margin-bottom: 1vh;
    }
    .real-data-l-item span{
        display: inline-block;
        width: 8vw;
        text-align: left;
    }
    .real-data-l-item .abr{
        position: absolute;
        bottom: 2vh;
        left: 40%;
        width: 3.5vw;
        height: 3vh;
        /* line-height: 25px; */
        font-size: 0.8vw;
        text-align: center;
        color: #707070;
        background: #c5c1c1;
        background: url(../../assets/image/box.png) no-repeat;
        background-size: 100% 100%;
    }
    .real-clock{
        width: 33%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    #wrap.real-clock-con{
        /* width:100%;
        height:calc( 100% - 3vh ); */
        /* padding:2vh 0; */
        margin-top: 3vh;
        width: 202px;
        height: 202px;
    }
    .main-dure{
        width:50%;
        height:100%;
        position: relative;
        padding-left:2vw;
        display:flex;
        flex-wrap:wrap;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
    .main-dure p{
        width: 100%;
        position: relative;
        height:4vh;
        display:flex;
     }
     .main-dure p span{
         width: 20%;
         position: relative;
     }
     .special-table{
         width: 100%;
         height: calc( 100% - 3vh );
         position: relative;
         padding: 1vh;
     }
     .no-photo{
         width:6vh;
         height:6vh;
         display: flex;
         justify-content: center;
         justify-items: center;
         align-content: center;
         background: #F5F7FA;
         flex-wrap: wrap;
         color:#C0C4CC;
     }
</style>
<style>
    .real-data .el-progress-bar__outer{
        background: #69BCFF;
    }
    .ele-real .el-progress-bar__inner{
        background-color: #038BF9;
    }
 @import '../../assets/css/common.css';
 .tower-dig .el-dialog__title{
      color: #0085FF;
    }
    .tower-dig .el-dialog__body,.tower-dig .el-dialog__footer{
      border-top: 1px solid #ddd;
    }
    .tower-dig span{
      font-weight: bold;
    }
    .tower-dig .el-dialog__header{
      text-align: left;
    }
    .config-con{
      display:flex;
      flex-wrap:wrap;
      width:100%;
      height:auto;
    }
    .config-con-item{
      width:100%;
      padding:1vh 0;
      display:flex;
      justify-content: space-around;
      align-items: center;
      align-content: center;
    }
    .item-one{
      width:100%;
      display: flex;
      align-items: center;
      margin-top: 20px ;
    }
    .main-left-scroll{
        width: 14.1vw;
        height: 96%;
        position: relative;
        padding: 1vh 0.3vh;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        background: #fff;
        align-content: flex-start;
    }
    .main-right-f{
        width: 100%;
        height: 42vh;
        display: flex;
        justify-content: space-between;
    }
    .main-right-f>.box1{
        background-color: #fff;
        height: 100%;
        width: 46.6%;
        box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
        border-radius: 6px;
        overflow: hidden;
    }

    .main-right-f>.box2{
        background-color: #fff;
        height: 100%;
        width: 52%;
        box-shadow: 2px 3px 7px 0px rgba(105, 159, 204, 0.5);
        border-radius: 6px;
        overflow: hidden;
    }
    .box-title{
        height: 5.5vh;
        line-height: 5.5vh;
        border-bottom: 1px solid #E7E7E7;
        padding-left: 3%;
        text-align: start;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #666666;
    }
    .box-cont{
        flex: 1;
        padding: 0 1.6vw;
        display: flex;
        justify-content: space-between;
    }
    .box1>.box-cont>.box-cont-l{
        padding: 1% 0;
    }
    .box1>.box-cont>.box-cont-r{
    width: 9.3vw;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    /* background-color: #f00; */
    padding: 6% 0;
}
    .box-S{
    height: 39.3vh;
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 1vh;
}

.p-text{
    text-align: start;
}
.el-table th.el-table__cell{
    background-color: #EFEFEFFF;
}
.special-table{
    padding: 0 !important;
}
.echrats{
    width: 36vw;
    height: 37vh;
    
}
.dis{
    display: none !important;
}
.box-second .main{
    height: calc( 100% - 6vh );
}
</style>